const e = {
  alwaysActive: {
    en: "Always active",
    es: "Siempre activo",
    "zh-Hans": "始终激活"
  }
};
export {
  e as messages
};
//# sourceMappingURL=messages4.mjs.map
